import React from 'react';

const Header = ({ showBrain = true, title, subtitle }) => {
    // Admin version uses static defaults unless specifically overridden
    const logo_tittle = 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Logo_4toNeuroUpdate.png';
    const brainImage = 'https://ftp.pcnpublicidad.com/neuroupdate/resources/Imagen_KV_Suelta.png';

    return (
        <header className="pt-10 pb-6 relative z-10 flex flex-col items-center w-full overflow-visible">
            <div className="relative w-full max-w-4xl px-4 flex flex-col items-center">
                {/* Header Container */}
                <div className="relative w-full flex items-center justify-center min-h-[180px] sm:min-h-[220px]">
                    
                    {/* Brain Visual (KV) */}
                    {showBrain && (
                        <div className="absolute top-1/2 left-1/2 -translate-x-[115%] -translate-y-[65%] sm:-translate-x-[130%] sm:-translate-y-[55%] 
                                        w-[240px] h-[240px] sm:w-[320px] sm:h-[320px] opacity-35 pointer-events-none select-none z-0">
                            <img
                                src={brainImage}
                                alt="Brain"
                                className="w-full h-full object-contain animate-pulse"
                                loading="lazy"
                            />
                        </div>
                    )}

                    {/* Logo Section */}
                    <div className="relative z-10 max-w-[240px] sm:max-w-[300px] drop-shadow-[0_10px_30px_rgba(255,255,255,0.1)]">
                        <img
                            src={logo_tittle}
                            alt="Logo"
                            className="w-full h-auto object-contain animate-pulse"
                            loading="lazy"
                        />
                    </div>
                </div>

                {/* Optional Title/Subtitle Overlay */}
                {(title || subtitle) && (
                    <div className="text-center mt-4 animate-fadeIn">
                        {title && <h2 className="text-xl sm:text-2xl font-black text-white tracking-tight uppercase italic">{title}</h2>}
                        {subtitle && <p className="text-white/40 text-[9px] sm:text-[10px] font-black uppercase tracking-[0.3em] mt-1">{subtitle}</p>}
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header;
